import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from '../../../api';
import { BeatLoader } from 'react-spinners';
import { RingLoader } from 'react-spinners';
import DraggableCamera from "./DraggableCamera";

import onlCamImg from "../../../images/onl-cam.svg";
import offlCamImg from "../../../images/offl-cam.svg";
import loadingCamImg from "../../../images/camera-rotate.png";
import unplacedCamImg from "../../../images/unplaced_cam.svg";
import deleteImg from "../../../images/delete.png";

import { useDrop } from 'react-dnd';
import { url } from '../../../api/endpointURL';
import UploadSitePlan from "./UploadSitePlan";
import SaveConfig from "./SaveConfig";
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
// import CustomTooltipMapZoom from "../../tooltips/CustomTooltipMapZoom";
import "../../../styles/siteplan.css";

import { listPlacedCamPositions } from '../../../redux/actions/listPlacedCamPositions';
import NoImageAvailable from "./noImageAvailable/NoImageAvailable";

// Import generic components
import Modal from "../../../generic_components/Modal/Modal";
import Tooltip from "../../../generic_components/Tooltip/Tooltip";
import { useToast } from "../../../generic_components/Toast/Toast";

const SitePlan = ({hwid, userBusinessRole}) => {
    const [fileToUpload, setFileToUpload] = useState('');
    const canvasRef = useRef(null);
    const canvascamImagesRef = useRef(null);
    const [searchItem, setSearchItem] = useState('');
    const [cameraPositions, setCameraPositions] = useState([]);
    const [isHovering, setIsHovering] = useState(false);
    const isSmallScreen = window.innerWidth < 600;

    const draggingRef = useRef(null);
    const draggingSiteMapRef = useRef(false);
    const lastMouse = useRef({ x: 0, y: 0 });

    const hoveringCamImg = useRef(null);

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [previewLocal, setPreviewLocal] = useState(null);
    const [previewUploaded, setPreviewUploaded] = useState(null);
    const [isUploaded, setIsUploaded] = useState(null);
    const [totalPlacedCams, setTotalPlacedCams] = useState(0);
    const [step, setStep] = useState(-1);
    const [uploadedUrl, setUploadedUrl] = useState(null);
    const [isSwitchOnPlaced, setIsSwitchOnPlaced] = useState(false);
    const [isSwitchOnUnplaced, setIsSwitchOnUnplaced] = useState(false);
    const [showRemoveCamConfirmation, setShowRemoveCamConfirmation] = useState(false);
    const [showUndoChangesConfirmation, setShowUndoChangesConfirmation] = useState(false);
    const [camNameToRemove, setCamNamToRemove] = useState('');
    const [camIdToRemove, setCamIdToRemove] = useState('');
    const devicesPerSite = useSelector(state => state.devicesPerSite);

    const [showModal, setShowModal] = useState(false);
    const [selectedCameraName, setSelectedCameraName] = useState('');
    const [selectedImageUrl, setSelectedImageUrl] = useState(null); 

    // image loaded state
    const [imageLoaded, setImageLoaded] = useState(false);
    const [animate, setAnimate] = useState(false);

    // Handle image load event
    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    const [totalCameras, setTotalCameras] = useState(0);
    const [totalOnlineCams, setTotalOnlineCameras] = useState(0);
    const [cameraList, setCameraList] = useState([]);
    const goToCameraPlacement = useRef(false);
    const prevMouseUp = useRef({x: 0, y: 0});
    // const [openGuidelinePopUp, setOpenGuidelinePopUp] = useState(false);

    const dispatch = useDispatch();
    const toast = useToast();

    const placedCameras = useSelector(state => state.placedCameras);

    // Extract only the camera objects + server
    useEffect(() => {
        let totalCameras = 0;
        let totalOnlineCams = 0;
        let camList = [];

        if (Object.keys(devicesPerSite).length <= 0 || !hwid) return;
            devicesPerSite?.servers?.forEach((server) => {
                // totalCameras += server.cameras.length;
                server.cameras.forEach((cameraObj) => {
                    cameraObj.server_name = server.server_name;
                    // if(cameraObj.camera_status === 1){
                        // totalOnlineCams += 1;
                    // }
                })
                camList.push(...server.cameras);
            });
            // Array of unique cam objects
            camList = [...new Map(camList.map(cam => [cam.camera_id, cam])).values()];
            totalCameras = camList.length;
            camList.forEach((cam) => {
                if(cam.camera_status === 1){
                    totalOnlineCams += 1;
                }
            })
            setTotalCameras(totalCameras);
            setTotalOnlineCameras(totalOnlineCams);
            setCameraList(camList);
    }, [devicesPerSite, hwid])

    // console.log(`Line 112 cameraList is ${JSON.stringify(cameraList, null, 2)}`);
    
    // Zooming
    const [zoom, setZoom] = useState(1); // current zoom scale 100%
    const [pan, setPan] = useState({x:0, y:0});
    const MAX_ZOOM = 4; // Max scale 400%
    const MIN_ZOOM = 1; // Min scale 100%
    const ZOOM_STEP = 1; // Zoom by 100%

    const camImageWidth = 30;
    const camImageHeight = 30;
        

    const findCamNameByID = (camera_id, cameraList) => {
        const camera = cameraList?.find((cam) => (cam.camera_id === camera_id));
        return camera?.camera_name;
    };

    const findCamStatusByID = (camera_id, cameraList) => {
        const camera = cameraList?.find((cam) => (cam.camera_id === camera_id));
        return camera?.camera_status;
    };

    const findCamOfflineSinceByID = (camera_id, cameraList) => {
        const camera = cameraList?.find((cam) => (cam.camera_id === camera_id));
        return camera?.cameraOfflineSince;
    };

    let fromSaveConfigToPlaceCams = useRef(false);
    // Fetch placed camera positions from db and store in cameraPositions
    useEffect(() => {
        const canvas = canvascamImagesRef.current;

        if (!canvas || step !== 2 || fromSaveConfigToPlaceCams.current) return;

        if (placedCameras.length > 0) {
            // console.log(`            CAMERA POSITIONS FETCHED                   `);
            const fullCamPos = placedCameras.map((cam) => ({
                ...cam,
                x: Math.round(cam.x * canvas.width * 100) / 100, // round to the second nearest decimal place
                y: Math.round(cam.y * canvas.height * 100) / 100, // round to the second nearest decimal place
                camera_name: findCamNameByID(cam.camera_id, cameraList),
                placed: true,
                camera_status: findCamStatusByID(cam.camera_id, cameraList),
                cameraOfflineSince: findCamOfflineSinceByID(cam.camera_id, cameraList),
                monthly_image_url: cam.monthly_image_url
            })) // Added extra fields to each of the objects

            // Remove duplicates of this array of objects by camera_id and only keep the last occurrence
            setCameraPositions((prev) => {
                const combined =  [...prev, ...fullCamPos];
                const uniqueCams = Array.from(
                        new Map(combined.map(cam => [cam.camera_id, cam])).values()
                );
                return uniqueCams;
            });
        }
    }, [hwid, placedCameras, cameraList, step])


    // prininting only
    // useEffect(()=> {
    //     console.log(` Line 172 RENDERING CAMERAS FROM SaveConfig ${JSON.stringify(cameraPositions, null, 2)}`);
    // }, [cameraPositions])
    // Fetch image URL
    useEffect(() => {
        if (!hwid) {
            setPreviewUploaded(null);
            return;
        }

        if (step === 1 || step === 2 || isUploaded === null) {
            const safeUrl = `${API.defaults.baseURL}/devices-sites/image-proxy/${encodeURIComponent(hwid)}?t=${Date.now()}`;

            const fetchURL = async(url) => {
                const res = await fetch(url, { method: 'HEAD', cache: 'no-cache', mode: 'cors' });
                return res;
            }

            // Fetch the API
            const fetchSetURL = async() => {
                try {
                    const result = await fetchURL(safeUrl);
                    if (result.status === 200) {
                        setPreviewUploaded(safeUrl);
                        setPreviewLocal(null); // Clear local preview on HWID change
                        setIsUploaded(true); // Once the image is rendered, set it to true
                        setUploadedUrl(safeUrl);
                        if(goToCameraPlacement.current){
                            setStep(1);
                        }
                        else{
                            setStep(2);
                        }
                    }
                    else {
                        setPreviewUploaded(null);
                        setPreviewLocal(null); // Clear local preview on HWID change
                        setIsUploaded(false);
                        setUploadedUrl(null);
                        setStep(0);
                    }
                }
                catch(err) {
                    console.error('Fetch failed', err);
                    setPreviewUploaded(null);
                    setPreviewLocal(null); // Clear local preview on HWID change
                    setIsUploaded(false);
                    setUploadedUrl(null);
                    setStep(0);
                }
            }
            // Call the function
            fetchSetURL();
        }        
    }, [hwid, step, isUploaded]);

    // Render the uploaded image
    useEffect(() => {
        const canvas = canvasRef.current;
        
        // if (!isUploaded || !canvas || !uploadedUrl || step !== 1) return;
        if (!isUploaded || !canvas || !uploadedUrl) return;
        // console.log(`                                   RENDERING IMAGE ${uploadedUrl}`)

        if (canvas) {
            const img = new Image(); // image object
            img.crossOrigin = 'anonymous'; // Allow cross-origin from S3
            img.src = uploadedUrl;

            img.onload = () => {
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height); // clear previous drawing
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.translate(pan.x, pan.y);
                ctx.scale(zoom, zoom);
                ctx.drawImage(img, 0, 0, canvas.width-40, canvas.height);

                // Draw border
                ctx.strokeStyle = 'rgba(255, 0, 0, 0.8)';
                ctx.lineWidth = 3;
                ctx.strokeRect(canvas.width-40, 0, canvas.width-40, canvas.height);

                ctx.fillStyle = 'rgba(211, 211, 211, 0.75)';
                ctx.fillRect(canvas.width-40, 0, canvas.width, canvas.height);
                const binImg = new Image();
                binImg.src = deleteImg; // path to your icon

                binImg.onload = () => {
                    ctx.drawImage(binImg, canvas.width-36, canvas.height/2, 30, 30);
                };
            }

            // Unable to load image
            img.onerror = (err) => {
                setPreviewUploaded(null);
                console.warn('Line 297 Image failed to load:', uploadedUrl)
            }
        }
    }, [isUploaded, uploadedUrl, zoom, pan]);
  
    const handleSearchItem = (e) => {
        setSearchItem(e.target.value);
    };

    const handleClearSearch = () => {
        setSearchItem('');
    };

    // Filter camera list based on search item
    let filteredCameraList = cameraList.filter((cameraObj) => (cameraObj.camera_name.toLowerCase().includes(searchItem.toLowerCase())));
    // console.log(`Line 281 the filteredCameralIst is ${JSON.stringify(filteredCameraList, null, 2)}`);

    const [, dropRef] = useDrop({
        accept: 'CAMERA',
        drop: (item, monitor) => {
            if (!isUploaded){
                toast.error(
                    <div className="failure-text-siteplan">
                        <span>Please upload your site plan first!</span>
                    </div>, 
                {
                    theme: "colored",
                    autoClose: 6000,
                })
                return;
            }
            
            const offset = monitor.getClientOffset(); // drop camera (x,y) position relative to viewport
            const canvas = canvascamImagesRef.current;
            const rect = canvas.getBoundingClientRect(); // position of canvas relative to viewport
    
            if (!canvas || !offset || !rect) return; // if null, exit the func
        
            // Position of dropped camera relative to canvas. Max val = 1
            const x_camPosCanvas = Math.min(offset.x - rect.x, canvas.width - camImageWidth);
            const y_camPosCanvas = Math.min(offset.y - rect.y, canvas.height - camImageHeight);

            setCameraPositions((prev) => [...prev, 
                {camera_id: item.camera_id,
                hwid: hwid,
                x: x_camPosCanvas < canvas.width-40 ? x_camPosCanvas : x_camPosCanvas-70, // if camera is placed within delete zone, move it backward a bit
                y: y_camPosCanvas,
                camera_name: item.camera_name, 
                placed: true, 
                camera_status: item.camera_status
                }
            ]);
        }
      });

    /*************************************************** Mouse Events *************************************************/
    // Retrieve position of the mouse relative to canvas
    const getMousePosition = (e) => {
        const canvas = canvascamImagesRef.current;
        const rect = canvas.getBoundingClientRect(); // position of canvas relative to viewport
        // Position of the mouse click on Canvas
        const mouseX = (e.clientX - rect.x);
        const mouseY = (e.clientY - rect.y);        
        return {mouseX, mouseY}
    };

    // Handle mouse click on canvas. Check if mouse click is on the dropped camera's position
    const handleOnMouseDown = (e) => {
        const {mouseX,mouseY} = getMousePosition(e); // position of the mouse click
        
        draggingSiteMapRef.current = true;
        lastMouse.current = { x: e.clientX, y: e.clientY }; // save where mouse went down

        // Convert mouse position from screen space to world space
        const worldMouseX = (mouseX - pan.x) / zoom;
        const worldMouseY = (mouseY - pan.y) / zoom;

        for (const placedCamera of cameraPositions) {
            // Check if the mouse click is on the current camera
            if (worldMouseX >= placedCamera.x && worldMouseX <= placedCamera.x+camImageWidth &&
                worldMouseY >= placedCamera.y && worldMouseY <= placedCamera.y+camImageHeight) {
                    draggingRef.current = placedCamera.camera_id; // reference to currently clicked camera
                    // Reset previous mouse up to current positions 
                    const lastCamPos = cameraPositions.filter(cam => cam.camera_id === placedCamera.camera_id);
                    prevMouseUp.current.x = lastCamPos[0].x;
                    prevMouseUp.current.y = lastCamPos[0].y;

                    setIsHovering(false);
                    draggingSiteMapRef.current = false;
            }
        }        
    };

    // Allows dragging camera icon around Canvas and update the camera position given the mouse is currently on the camera
    const handleOnMouseMove = async(e) => {
        const {mouseX,mouseY} = getMousePosition(e); // position of the mouse move on Canvas
        const canvas = canvascamImagesRef.current;
        
        // Dragging camera icon
        if (draggingRef.current) {
            // if current camera icon is clicked
            const cameraId = draggingRef.current; // current dragging camera
            // Update the position of the clicked camera
            setCameraPositions((prev) => 
                prev.map(camera => 
                    // camera.camera_id === cameraId ? {...camera, x: Math.min(mouseX, canvas.width - camImageWidth), y: Math.min(mouseY, canvas.height - camImageHeight)} : camera
                    // Clamp cam position such that 0<=x<=770px and 0<=y<=570px
                    camera.camera_id === cameraId ? {...camera, x: Math.min(Math.max(0,mouseX), canvas.width - camImageWidth), y: Math.min(Math.max(0,mouseY), canvas.height - camImageHeight)} : camera
                )
            );
        }
        // Check if mouse cursor is on the camera, set isHovering = true and capture the camera_id.
        else if (draggingSiteMapRef.current) {
            if (zoom === 1) return; // don't let user drag the plan when zoom = 1
            if (pan.x > 0 || pan.y > 0) return;
            const dx = e.clientX - lastMouse.current.x;
            const dy = e.clientY - lastMouse.current.y;

            const canvas = canvasRef.current;
            const zoomedWidth = canvas.width * zoom;
            const zoomedHeight = canvas.height * zoom;
          
            const minX = canvas.width - zoomedWidth;
            const minY = canvas.height - zoomedHeight;
            const maxX = 0;
            const maxY = 0;
          
            setPan((prev) => ({
              x: Math.min(maxX, Math.max(minX, prev.x + dx)),
              y: Math.min(maxY, Math.max(minY, prev.y + dy)),
            }));
            lastMouse.current = { x: e.clientX, y: e.clientY };
        } 
        else {
            // Convert mouse position from screen space to world space
            const worldMouseX = (mouseX - pan.x) / zoom;
            const worldMouseY = (mouseY - pan.y) / zoom;

            setIsHovering(false);
            hoveringCamImg.current = null;
            // Hovering on camera icons
            for (const placedCamera of cameraPositions) { 
                // Check if the mouse cursor is on the current camera
                if (worldMouseX >= placedCamera.x && worldMouseX <= placedCamera.x+camImageWidth &&
                    worldMouseY >= placedCamera.y && worldMouseY <= placedCamera.y+camImageHeight) {
                        hoveringCamImg.current = placedCamera.camera_id;
                        setIsHovering(true);
                }
            }
        }
    };

    // Handle mouseup
    const stopDragging = async(e) => {
        const canvas = canvasRef.current;
        const {mouseX, mouseY} = getMousePosition(e); // position of the mouse drop on Canvas

        // On mouse release, set the position of the camera to previous position before delete zone
        if (mouseX < canvas.width - 40) {
            prevMouseUp.current = {x: mouseX, y: mouseY};
        }
        // console.log(`Line 587 the prev mouse up is ${prevMouseUp.current.x}, ${prevMouseUp.current.y}`);
        // When mouseup in the delete zone, remove camera from cameraPositions and draggingRef.current=null
        if (draggingRef.current){ 
            // if current camera icon is clicked
            const cameraId = draggingRef.current; // current dragging camera
            const cameraName = findCamNameByID(cameraId, cameraList);
            if(mouseX >= canvas.width - 40){
                setShowRemoveCamConfirmation(true);
                setCamIdToRemove(cameraId);
                setCamNamToRemove(cameraName);
            }
        }

        draggingRef.current = null;
        hoveringCamImg.current = null;
        draggingSiteMapRef.current = false;
    };

    // Remove cam on drag and drop
    const handleRemoveCam = async(cameraId, cameraName) => {    
        setShowModal(false);           
        let message;
        // Remove the camera from site plan
        try{
            const response = await fetch(`${url}/cameras-map?camera_id=${cameraId}`, {
                method: 'DELETE',
            });
            
            // Successful
            if (response.status === 200){
                // remove camera from array
                setCameraPositions((prev) => 
                    prev.filter(cam => cam.camera_id !== cameraId)
                );
                draggingRef.current = null;
                message = 
                (<div className="success-text-siteplan">
                    <span>You have successfully removed camera {cameraName} from the layout!</span>
                </div>)
                toast.success(message, 
                {
                    theme: "colored",
                    autoClose: 6000,
                });
                dispatch(listPlacedCamPositions(hwid)); // added
            }            
            else {
                // Camera id is not found in db
                if (response.status === 404) {
                    // remove camera from layout
                    setCameraPositions((prev) => 
                        prev.filter(cam => cam.camera_id !== cameraId)
                    );
                    draggingRef.current = null;                                
                    message=
                    (<div className="failure-text-siteplan">
                        <span>Camera {cameraName} location was not saved yet. Removed from the layout only.</span>
                    </div>)
                    toast.info(message, 
                    {
                        theme: "colored",
                        autoClose: 6000,
                    })
                }
            }
        }
        catch (error) {
            console.log(error);
            message = (
                <div className="failure-text-siteplan">
                    <span>Failed to delete camera {cameraName}: {error}</span>
                </div>
            )

            toast.error(message, 
            {
                theme: "colored",
                autoClose: 6000,
            })
        }
        setShowRemoveCamConfirmation(false);
    }

    // Hide the confirmation modal
    const cancelRemoveCam = (cameraId) => {
        setShowRemoveCamConfirmation(false);
        setCameraPositions((prev) =>
            prev.map(cam => (
                (cam.camera_id === cameraId) ? 
                {...cam, x: prevMouseUp.current.x, y: prevMouseUp.current.y} : cam
            ))
        )
    }

    // Leave any bounding boxes
    const stopHovering = () => {
        draggingRef.current = null;
        hoveringCamImg.current = null;
        draggingSiteMapRef.current = false;
    };

    // Handle Zoom In +
    const handleZoomIn = () => {
        const canvas = canvasRef.current;
        const newZoom = Math.min(zoom + ZOOM_STEP, MAX_ZOOM); // increase scale by 100%
        setZoom(newZoom); // scale up by 100%, otherwise 400% if exceeding
        
        const centerX = canvas.width/2 - 20; // Leave 40centerX for delete zone
        const centerY = canvas.height/2;

        const worldX = (centerX-pan.x)/zoom;
        const worldY = (centerY-pan.y)/zoom;

        const newPan = {
            x: centerX - worldX * newZoom,
            y: centerY - worldY * newZoom
        }

        setPan(newPan);
    };

    // Handle Zoom Out -
    const handleZoomOut = () => {
        const canvas = canvasRef.current;
        const newZoom = Math.max(zoom - ZOOM_STEP, MIN_ZOOM); // decrease scale by 100%
        setZoom(newZoom); // scale down by 100%, otherwise 100% when < 100%        

        // If zooming out to MIN_ZOOM, reset everything
        if (newZoom <= MIN_ZOOM){
            setZoom(1);
            setPan({x:0, y:0});
            return;
        }
        
        const centerX = canvas.width/2 - 20; // Leave 40centerX for delete zone
        const centerY = canvas.height/2;

        const worldX = (centerX-pan.x)/zoom;
        const worldY = (centerY-pan.y)/zoom;

        const newPan = {
            x: Math.min(centerX - worldX * newZoom, 0),
            y: Math.min(centerY - worldY * newZoom, 0)
        }
        setPan(newPan);
    };

    const handleUndoZoomPan = () => {
        setZoom(1);
        setPan({x:0, y:0});
    };

    // Toggle Placed On or Off
    const handleSwitchChangePlaced = () => {
        setIsSwitchOnPlaced(!isSwitchOnPlaced);
    };

    // Toggle Unplaced On or Off
    const handleSwitchChangeUnplaced = () => {
        setIsSwitchOnUnplaced(!isSwitchOnUnplaced);
    };

    // If placed switch is on, show cameras with placed   
    if (isSwitchOnPlaced) {
        filteredCameraList = filteredCameraList.filter((cameraObj) => {
            // If there is placed cam, cross check with cameraPositions if it's placed
            if (cameraPositions.length > 0) {
                for (const cam of cameraPositions) {
                    if (cameraObj.camera_id === cam.camera_id){
                        return true;
                    }
                }
                return false;
            }
            // otherwise, don't return anything
            else {
                return false;
            }
        });
    };

    // If unplaced switch is on, show cameras with unplaced    
    if (isSwitchOnUnplaced) {
        filteredCameraList = filteredCameraList.filter((cameraObj) => {
            // Check if given camera id exists in the cameraPositions, if no, cam is unplaced
            const temp = cameraPositions.filter(cam => (cam.camera_id === cameraObj.camera_id));
            if (temp.length === 0) {
                return true;  
            }
            else {
                return false;
            }
        });
    };

    /*************************************************  TOUCH EVENTS *********************************************************/
    // Retrieve position of the mouse relative to canvas
    const getTouchPosition = (e) => {
        const touch = e.touches[0];
        const canvas = canvascamImagesRef.current;
        const rect = canvas.getBoundingClientRect(); // position of canvas relative to viewport
        
        // Need to scale the coordinates of touch since it's smaller(touch) screen
        const scaleX = canvas.width/rect.width; // 800/CssWidth
        const scaleY = canvas.height/rect.height; // 600/CssWidth

        const touchX = (touch.clientX - rect.x) * scaleX;
        const touchY = (touch.clientY - rect.y) * scaleY;

        return {touchX, touchY}
    };

    // Retrieve position of the mouse relative to canvas
    const getLastTouchPosition = (e) => {
        const touch = e.changedTouches[0];
        const canvas = canvascamImagesRef.current;
        const rect = canvas.getBoundingClientRect(); // position of canvas relative to viewport

        // Need to scale the coordinates of touch since it's smaller(touch) screen
        const scaleX = canvas.width/rect.width; // 800/CssWidth
        const scaleY = canvas.height/rect.height; // 600/CssWidth

        const touchX = (touch.clientX - rect.x) * scaleX;
        const touchY = (touch.clientY - rect.y) * scaleY;

        return {touchX, touchY}
    };

    // For touch event
    const handleOnTouchStart = (e) => {  
        if (draggingRef.current) {        
                return;
        }     

        const touch = e.touches[0];
        const {touchX, touchY} = getTouchPosition(e);
        // Convert touch position from screen space to world space
        const worldTouchX = (touchX - pan.x) / zoom;
        const worldTouchY = (touchY - pan.y) / zoom;
        
        draggingSiteMapRef.current = true;
        lastMouse.current = { x: touch.clientX, y: touch.clientY };

        for (const placedCamera of cameraPositions) { 
            // Check if the mouse click is on the current camera
            if (worldTouchX >= placedCamera.x && worldTouchX <= placedCamera.x+camImageWidth &&
                worldTouchY >= placedCamera.y && worldTouchY <= placedCamera.y+camImageHeight) {
                    draggingRef.current = placedCamera.camera_id; // reference to currently clicked camera
                    // Reset previous mouse up to current positions 
                    const lastCamPos = cameraPositions.filter(cam => cam.camera_id === placedCamera.camera_id);
                    prevMouseUp.current.x = lastCamPos[0].x;
                    prevMouseUp.current.y = lastCamPos[0].y;

                    setIsHovering(false);
                    draggingSiteMapRef.current = false;

                    const newImageUrl = placedCamera.monthly_image_url;
                    const newCameraName = placedCamera.camera_name;
                    if (selectedImageUrl !== newImageUrl || selectedCameraName !== newCameraName) {
                            setSelectedImageUrl(newImageUrl);
                            setSelectedCameraName(newCameraName);
                    }
                    setShowModal(true);
                    break;
            }                
        }       
    };

    // For touch to move event
    const handleOnTouchMove = async(e) => {
          setShowModal(false);
        // e.preventDefault(); // prevent page scroll/zoom when moving 
        const canvas = canvascamImagesRef.current;
        const touch = e.touches[0];
        const {touchX,touchY} = getTouchPosition(e); // position of the mouse move on Canvas
        
        // Dragging camera icon
        if (draggingRef.current) {
            // if current camera icon is clicked
            const cameraId = draggingRef.current; // current dragging camera

            // Update the position of the clicked camera
            setCameraPositions((prev) => 
                prev.map(camera => 
                    // Clamp cam position such that 0<=x<=770px and 0<=y<=570px
                    camera.camera_id === cameraId ? {...camera, x: Math.min(Math.max(0,touchX), canvas.width - camImageWidth), y: Math.min(Math.max(0,touchY), canvas.height - camImageHeight)} : camera
                )
            );
        }
        // Check if mouse cursor is on the camera, set isHovering = true and capture the camera_id.
        else if (draggingSiteMapRef.current) {
            if (zoom === 1) return; // don't let user drag the plan when zoom = 1
            if (pan.x > 0 || pan.y > 0) return;
            const dx = touch.clientX - lastMouse.current.x;
            const dy = touch.clientY - lastMouse.current.y;

            const canvas = canvasRef.current;
            const zoomedWidth = canvas.width * zoom;
            const zoomedHeight = canvas.height * zoom;
            
            const minX = canvas.width - zoomedWidth;
            const minY = canvas.height - zoomedHeight;
            const maxX = 0;
            const maxY = 0;
            
            setPan((prev) => ({
                x: Math.min(maxX, Math.max(minX, prev.x + dx)),
                y: Math.min(maxY, Math.max(minY, prev.y + dy)),
            }));
            lastMouse.current = { x: touch.clientX, y: touch.clientY };
        } 
        // Check if touch cursor is on the camera, set isHovering = true and capture the camera_id. 
        else {
            setIsHovering(false);
            hoveringCamImg.current = null;

            const worldTouchX = (touchX - pan.x) / zoom;
            const worldTouchY = (touchY - pan.y) / zoom;

            // Hovering on camera icons
            for (const placedCamera of cameraPositions) { 
                // Check if the touch cursor is on the current camera
                if (worldTouchX >= placedCamera.x && worldTouchX <= placedCamera.x+camImageWidth &&
                    worldTouchY >= placedCamera.y && worldTouchY <= placedCamera.y+camImageHeight) {
                        hoveringCamImg.current = placedCamera.camera_id;
                        setIsHovering(true);
                }
            }
        }
    };
    
    // Untouch
    const stopDraggingTouch = async(e) => {
        const canvas = canvasRef.current;
        const {touchX, touchY} = getLastTouchPosition(e); // position of the mouse move on Canvas

        // On touch release, set the position of the camera to previous position before delete zone
        if (touchX < canvas.width - 40) {
            prevMouseUp.current = {x: touchX, y: touchY};
        }

        // When mouseup in the delete zone, remove camera from cameraPositions and draggingRef.current=null
        if (draggingRef.current){ 
            // if current camera icon is clicked
            const cameraId = draggingRef.current; // current dragging camera
            const cameraName = findCamNameByID(cameraId, cameraList); 
            // For dragging the camera icon to delete zone, remove camera from cameraPositions and draggingRef.current=null.
            if(touchX >= canvas.width - 40){
                setShowRemoveCamConfirmation(true);
                setCamIdToRemove(cameraId);
                setCamNamToRemove(cameraName);
            }        
        }
        draggingRef.current=null;
        hoveringCamImg.current = null;
        draggingSiteMapRef.current = false;
    };

    // Promise to fully load images
    function loadImage(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                resolve(img);
            }

            img.onerror = () => {
                reject(new Error(`Failed to load image: ${url}`)); // loading failed
            };

            img.src = url; // Start loading the image
        });
    };


    const utcStrToLocal = (utcTimestamp) => {
        // Create a Date object using the UTC timestamp
        const utcDate = new Date(utcTimestamp);
        // Get the local time components
        const localYear = utcDate.getFullYear();
        const localMonth = utcDate.getMonth() + 1; // Months are zero-based
        const localDay = utcDate.getDate();
        const localHours = utcDate.getHours();
        const localMinutes = utcDate.getMinutes();
        const localSeconds = utcDate.getSeconds();
        // Create a new Date object with the local time components
        const localDate = new Date(localYear, localMonth - 1, localDay, localHours, localMinutes, localSeconds);
        // Format the local time as needed
        const formattedLocalTime = localDate.toLocaleString();
        return formattedLocalTime
    }

    // Remove cameras when there is no camera name or camera name is undefined. (For case when cam does not exist in CAMERAS_INFO table) 
    const sanitise_cam_list = (camPositions) => {
        const camsToRender = [];
        for (const cam of camPositions) {
            if (cam.camera_name) {
                camsToRender.push(cam);
            }
        }
        return camsToRender;
    }

    // Can render the cameras positions from db after. It's not expensive to redraw hundreds of images of size 30 x `30`. 
    useEffect(() => {        
        const canvas = canvascamImagesRef.current; // Camera Icons Canvas Layer reference
        if (!canvas || step !== 1) return;

        // console.log(`                              RENDERING CAMERAS FROM SaveConfig ${JSON.stringify(cameraPositions, null, 2)}`);

        // Only include cameras when its camera_name exists. Remove cam when there is no camera_name or it is undefined.
        const camsToRender = sanitise_cam_list(cameraPositions);

        // console.log(`Line 241 the sanitised cam list is ${JSON.stringify(camsToRender, null, 2)}`);

        const dateTimeUTC = (datetime) => {
            let deviceOfflineSince = datetime;
            if (datetime !== null) {
                deviceOfflineSince = utcStrToLocal(datetime);
            }
            return deviceOfflineSince;
        };

        const ctx = canvas.getContext('2d');
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.translate(pan.x, pan.y);
        ctx.scale(zoom, zoom);

        // console.log(`Line 498 the cameras rendered on site plan are ${JSON.stringify(cameraPositions, null, 2)}`);
        // Calculate number of placed cams
        setTotalPlacedCams(0);
        for (const cam of camsToRender){
            if (cam.placed){
                setTotalPlacedCams(prev => prev + 1);
            }
        }

        // Ensure all given images are fully loaded, then use them for rendering
        Promise.all([
            loadImage(onlCamImg),
            loadImage(offlCamImg),
            loadImage(loadingCamImg),
        ])
        .then(([onlineImg, offlineImg, loadingImg]) => {
            ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear previous drawing but wait for the camera image to load first for smooth transition 
            for (const placedCamera of camsToRender) {
                const img = placedCamera?.camera_status === 1 
                ? onlineImg 
                : (placedCamera?.camera_status === 0 ? offlineImg: loadingImg);
                ctx.drawImage(img, placedCamera.x, placedCamera.y, camImageWidth, camImageHeight); // place image at drop position and resize it
                // Hover on camera image
                if (isHovering && placedCamera.camera_id === hoveringCamImg.current) {
                    const textMetrics = ctx.measureText(placedCamera.camera_name);
                    const textWidth = textMetrics.width;
                    const padding = 20;
                    let yShift = 13;
                    let xShift = 30;
                    // If x <= background width/2, put text to right
                    if(placedCamera.x <= (textWidth+padding)/2) {
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x+xShift, placedCamera.y, textWidth, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`, placedCamera.x+textWidth/2+xShift, placedCamera.y+yShift);

                        // cameraOfflineSince
                        if (placedCamera.cameraOfflineSince) {
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x+xShift, placedCamera.y + 17, textWidth, padding);
                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`, placedCamera.x+textWidth/2+xShift, placedCamera.y+yShift + 17);
                        }
                    }                    
                    // If x + background width/2 >= max width, put text to left
                    else if (placedCamera.x + (textWidth+padding)/2 >= canvas.width) {
                        // camera_name
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x-textWidth, placedCamera.y, textWidth, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`, placedCamera.x-textWidth/2, placedCamera.y+yShift);

                        // cameraOfflineSince
                        if (placedCamera.cameraOfflineSince) {
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-textWidth, placedCamera.y + 17, textWidth, padding);
                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`, placedCamera.x-textWidth/2, placedCamera.y+yShift+17);
                        }
                    }
                    // If y + background height >= max height, put text to top 
                    else if (placedCamera.y + (padding + 30) >= canvas.height){    
                        // camera_name                    
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y-20, textWidth+padding, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`,placedCamera.x, placedCamera.y+yShift-20);

                        if (placedCamera.cameraOfflineSince) {
                            // camera_name                    
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y-20-17, textWidth+padding, padding);
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${placedCamera.camera_name}`,placedCamera.x, placedCamera.y+yShift-20-17);

                            // cameraOfflineSince
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y-20, textWidth+padding, padding);                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`,placedCamera.x, placedCamera.y+yShift-20);
                        }
                    }
                    // Camera icon is not near any of the edges
                    else {
                        // camera_name                      
                        ctx.fillStyle = "#e08a20";
                        ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y + yShift + 17, textWidth+padding, padding);
                        
                        ctx.fillStyle = "white";
                        ctx.textAlign = "center";
                        ctx.fillText(`${placedCamera.camera_name}`,placedCamera.x, placedCamera.y + (yShift+30));

                        // cameraOfflineSince
                        if (placedCamera.cameraOfflineSince) {
                            ctx.fillStyle = "#e08a20";
                            ctx.fillRect(placedCamera.x-(textWidth+padding)/2, placedCamera.y + yShift + 17 + 17, textWidth+padding, padding);
                            
                            ctx.fillStyle = "white";
                            ctx.textAlign = "center";
                            ctx.fillText(`${dateTimeUTC(placedCamera.cameraOfflineSince)}`,placedCamera.x, placedCamera.y + (yShift+30) + 17);
                        }
                    }
                }
            }
        })

    }, [cameraPositions, isHovering, isUploaded, step, zoom, pan]);

// Handle click on canvas
const handleCanvasClick = (e) => {
    if (draggingRef.current) {        
        return;
    }

    const deltaX = Math.abs(e.clientX - lastMouse.current.x);
    const deltaY = Math.abs(e.clientY - lastMouse.current.y);
    const dragDistance = Math.sqrt(deltaX ** 2 + deltaY ** 2);

    if (dragDistance > 5) {
        // console.log("Blocked modal because it was a drag, not a click");
        return; // 👈 This was a drag, not a click
    }

    // ... existing canvas click code
    const canvas = canvascamImagesRef.current;
    const rect = canvas.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;

    for (const placedCamera of cameraPositions) {
        const camX = placedCamera.x;
        const camY = placedCamera.y;
        const withinX = clickX >= camX && clickX <= camX + camImageWidth;
        const withinY = clickY >= camY && clickY <= camY + camImageHeight;

        if (withinX && withinY) {
            // const newImageUrl = placedCamera.monthly_image_url;
            const newImageUrl = placedCameras.find(cam => cam.camera_id === placedCamera.camera_id)?.monthly_image_url;
            const newCameraName = placedCamera.camera_name;

            if (selectedImageUrl !== newImageUrl || selectedCameraName !== newCameraName) {
                setSelectedImageUrl(newImageUrl);
                setSelectedCameraName(newCameraName);
            }

            setShowModal(true);
            break;
        }
    }
};


    // Handle image load for animation
    useEffect(() => {
        if (imageLoaded) {
            // Delay slightly to ensure we see the blur effect
            const timer = setTimeout(() => setAnimate(true), 50);
            return () => clearTimeout(timer);
        } else {
            setAnimate(false);
        }
    }, [imageLoaded]);

    // Close the image render modal
    const closeModal = () => {
        setShowModal(false);
        setImageLoaded(false); // Reset states
        setAnimate(false);
    };


    // Save coordinates of dropped cameras to db
    const handleSaveLayout = async() => {
        const canvas = canvascamImagesRef.current;
        // exclude unneccessary key value pair out
        const payload = cameraPositions.map(({placed, camera_name, ...rest}) => rest);
        
        // Normalised the (x,y) coordinates
        for (const cam of payload) {
            cam.x = cam.x/canvas.width;
            cam.y = cam.y/canvas.height;
        }

        // Insert if no entry in the db table. If there is an entry, update the coordinates
        let message;

        try {
            const response = await fetch(`${url}/cameras-map`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            
            const res = await response.json();

            // Successful Save Layout
            if (response.status === 200){
                message =
                (<div className="success-text-siteplan">
                    <span>You have successfully saved the camera locations! Changes will take effect within 5 minutes. </span>                        
                </div>)
                toast.success(message, 
                {
                    theme: "colored",
                    autoClose: 6000,
                })
                dispatch(listPlacedCamPositions(hwid));
                // fromSaveConfigToPlaceCams.current = false;
            }            
            else {
                message =
                (<div className="failure-text-siteplan">
                    <span>{res.error}</span>                        
                </div>)

                toast.error(message, 
                {
                    theme: "colored",
                    autoClose: 6000,
                });
            }
        }
        catch (error) {
            console.error('Error:', error);
            message =
            (<div className="failure-text-siteplan">
                <span>Failed to save layout changes: {error}</span>                        
            </div>)

            toast.error(message, 
            {
                theme: "colored",
                autoClose: 6000,
            })
        }
    };

    // Handle undo all unsaved changes by refetching the cameras
    const handleUndoUnsavedChanges = async() => {
        const canvas = canvascamImagesRef.current;
        setShowUndoChangesConfirmation(false);
        let message;

        dispatch(listPlacedCamPositions(hwid)); // added

        const fullCamPos = placedCameras.map((cam) => ({
            ...cam,
            x: Math.round(cam.x * canvas.width * 100) / 100, // round to the second nearest decimal place
            y: Math.round(cam.y * canvas.height * 100) / 100, // round to the second nearest decimal place
            camera_name: findCamNameByID(cam.camera_id, cameraList),
            placed: true,
            camera_status: findCamStatusByID(cam.camera_id, cameraList),
            cameraOfflineSince: findCamOfflineSinceByID(cam.camera_id, cameraList)
        }))
        setCameraPositions(fullCamPos); // cameraPositions will just have fetched camera positions from db
        message = 
        (<div className="success-text-siteplan">
            <span>All unsaved changes were successfully discarded!</span>
        </div>)
        
        toast.success(message, 
        {
            theme: "colored",
            autoClose: 6000,
        })
    };

    // Hide the confirmation modal
    const cancelUndoChanges = () => {
        setShowUndoChangesConfirmation(false);
    }

    const handleGoToCameraPlacement = () => {
        setStep(1);
        goToCameraPlacement.current = true;
        fromSaveConfigToPlaceCams.current = true;
    };

    const handleGoToSaveConfig = () => {
        setStep(2);
        goToCameraPlacement.current = false;
    };

    const handleGoToUploadFile = () => {
        setStep(0);
    };

    return (
        
        <>
        {/* Upload a file component */}
        {
        (isUploaded === false || step === 0) ? 
        <UploadSitePlan
        hwid = {hwid} 
        loading={loading}
        setLoading = {setLoading}
        message={message}
        setMessage = {setMessage}
        fileToUpload = {fileToUpload}
        setFileToUpload = {setFileToUpload}
        isUploaded = {isUploaded}
        setIsUploaded = {setIsUploaded}
        previewLocal = {previewLocal}
        setPreviewLocal = {setPreviewLocal}
        previewUploaded = {previewUploaded}
        setPreviewUploaded = {setPreviewUploaded}
        setStep = {setStep}
        handleGoToCameraPlacement = {handleGoToCameraPlacement}
        step = {step}
        canvasRef = {canvasRef}
        canvascamImagesRef = {canvascamImagesRef}
        userBusinessRole = {userBusinessRole}
        />
        :
        // If isUploaded is null, render ring loader, otherwise, render camera placements + site plan
        isUploaded === null ?
            <div 
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            >
            <RingLoader size={ isSmallScreen ? 200 : 400} color="#F49523"/> 
            </div>
            // isUploaded is true, render camera placements + site plan component
            :
            (step === 1) ?
            <div className="site-mapping-container">
                <div className="progress-steps">
                    <div className="step completed">
                        <div className="step-number">✓</div>
                        <span>Upload Site Plan</span>
                    </div>
                    <div className="step active">
                        <div className="step-number">2</div>
                        <span>Place Cameras</span>
                    </div>
                    <div className="step incompleted">
                        <div className="step-number">3</div>
                        <span>Save Configuration</span>
                    </div>
                </div>

                <div className="camera-siteplan-container">
                    {/* Camera list  */}
                    <div className="camera-list-buttons-container">
                        <p className="camera-header">Available Cameras</p>
                        <div className="total-cameras-and-search-box-container">
                            <div className="search-camera-container">
                                <i className="fas fa-search"></i>
                                <input
                                className="search-camera-box"
                                type="text"
                                value={searchItem}
                                onChange={handleSearchItem}
                                placeholder="Search Camera..."
                                />
                                {searchItem && (
                                <span
                                    className="clear-icon-camera"
                                    onClick={() => handleClearSearch()}
                                >
                                    &times; {/* This is the "X" icon */}
                                </span>
                                )}
                            </div>
                        </div>

                        {/* Legends */}
                        <div className="legend">
                            <div className="legend-title">
                                Legend
                            </div>
                            <div className="legend-items">
                                <div className="legend-cam-placed">
                                    <div className="legend-item-placed">
                                        <img src={onlCamImg} alt="cam-img" className="cam-img-legend"></img>
                                        Placed
                                        <div className=''>
                                            <Form>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom-switch"
                                                    // label="Placed"
                                                    checked={isSwitchOnPlaced}
                                                    onChange={handleSwitchChangePlaced}
                                                />
                                            </Form>
                                        </div>
                                    </div>
                                    
                                    <div className="legend-item-placed">
                                        <img src={unplacedCamImg} alt="cam-img" className="cam-img-legend"></img>
                                        Unplaced
                                        <div className=''>
                                            <Form>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom-switch"
                                                    // label="Unplaced"
                                                    checked={isSwitchOnUnplaced}
                                                    onChange={handleSwitchChangeUnplaced}
                                                />
                                            </Form>
                                        </div>
                                    </div>
                                </div>

                                <div className="legend-cam-status">
                                    <div className="legend-item-status">
                                        <div className="legend-dot" style={{background: '#1cfd51'}}></div>
                                        Online Camera
                                    </div>
                                    <div className="legend-item-status">
                                        <div className="legend-dot" style={{background: '#bb201e'}}></div>
                                        Offline Camera
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Stats */}
                        <div className="stats-container">
                            <div className="stat">
                                <div className="total-cam" style={{color: 'white', fontWeight: 'bold'}}>{totalCameras}</div>
                                <div className="stat-title">Total</div>
                            </div>
                            <div className="stat">
                                <div className="total-cam" style={{color: 'rgb(28, 253, 81)'}}>{totalOnlineCams}</div>
                                <div className="stat-title">Online</div>
                            </div>
                            <div className="stat">
                                <div className="total-cam" style={{color: 'rgb(187, 32, 30)'}}>{totalCameras-totalOnlineCams}</div>
                                <div className="stat-title">Offline</div>
                            </div>
                            <div className="stat" style={{border:"none"}}>
                                <div className="total-cam" style={{color: '#7b8185'}}>{totalCameras - totalPlacedCams}</div>
                                <div className="stat-title">Unplaced</div>
                            </div>
                        </div>

                        <hr></hr>

                        {/* Draggable Cameras */}
                        <div className="camera-list-container">
                            {
                            totalCameras > 0 ?
                                filteredCameraList.length > 0 ?
                                    filteredCameraList?.map((cameraObj, index) => (
                                        <DraggableCamera
                                        key={index}
                                        cameraObj={cameraObj} 
                                        index={index}
                                        placedCamera={cameraPositions.find((camera) => (camera.camera_id === cameraObj.camera_id))}
                                        />
                                    ))
                                :
                                <p className="no-camera-avail"> No cameras available</p>
                            :
                                <p className="no-camera-avail"> No cameras available </p>
                            }
                        </div>

                        {/* <div className="save-reset-buttons"> */}
                            {/* <button className="save-button" onClick={handleSaveLayout} disabled={cameraPositions.length>0?false:true}>Save Camera Locations</button> */}
                            {/* <button className="reset-button">Delete Layout</button> */}
                        {/* </div> */}
                    </div>

                    {/* Site Plan */}
                    <div className="siteplan-overall-container">
                        <div className="zoom-preview-container">
                            {/* If user only wants to preview image */}
                            {
                                (previewLocal && !loading) &&
                                <div className="preview-container">
                                    <h4>Image Preview</h4>
                                </div>
                            }
                            {
                                loading && 
                                <div className="loading-container">
                                    <BeatLoader size={10} color="#36d7b7"/>
                                </div>
                            }
                        </div>
                        {/* Site Plan layer */}
                        <div className="siteplan-container">
                            {!isSmallScreen ?
                            // COMPUTER VIEW
                            <>
                                {/* Site Plan layer */}
                                <canvas
                                    ref={canvasRef}
                                    width={800}
                                    height={600}
                                    // style={{border: '1px solid #e08a20', position: 'absolute'}}
                                    style={{ position: 'absolute'}}
                                >
                                </canvas>

                                {/* Camera Icons layer  */}
                                <canvas
                                    onClick={handleCanvasClick}
                                    onMouseDown={handleOnMouseDown}
                                    onMouseUp={stopDragging}
                                    onMouseMove={handleOnMouseMove}
                                    onMouseLeave={stopHovering}
                                    ref={(node) => {
                                        canvascamImagesRef.current=node;
                                        dropRef(node);
                                    }}
                                    width={800}
                                    height={600}
                                    // style={{border: '1px solid #e08a20', position: 'absolute'}}
                                    style={{position: 'absolute'}}
                                >
                                </canvas>                               
                            </>
                            :
                            // MOBILE VIEW
                            <>
                                {/* Site Plan layer */}
                                <canvas
                                    ref={canvasRef}
                                    width={800}
                                    height={600}
                                    // style={{border: '1px solid #e08a20', position: 'absolute'}}
                                    style={{ position: 'absolute'}}
                                    className="canvas-siteplan-small"
                                >
                                </canvas>

                                {/* Camera Icons layer  */}
                                <canvas                                  
                                    onTouchStart={handleOnTouchStart}
                                    onTouchMove={handleOnTouchMove}
                                    onTouchEnd={stopDraggingTouch}
                                    ref={(node) => {
                                        canvascamImagesRef.current=node;
                                        dropRef(node);
                                    }}
                                    width={800}
                                    height={600}
                                    // style={{border: '1px solid #e08a20', position: 'absolute'}}
                                    style={{position: 'absolute'}}
                                    className="canvas-siteplan-small"
                                >
                                </canvas>
                            </>
                            }
                        </div>
                        <div className="zoom-container">
                            <Tooltip content='Zoom in' placement="top">
                                <button onClick={handleZoomIn}><i className="fa-solid fa-plus"></i></button>
                            </Tooltip>
                            <Tooltip content='Zoom out' placement="top">
                                <button onClick={handleZoomOut}><i className="fa-solid fa-minus"></i></button>
                            </Tooltip>
                            <Tooltip content='Reset' placement="top">
                                <button onClick={handleUndoZoomPan}><i className="fas fa-undo"></i></button>
                            </Tooltip>
                        </div>

                        {/* Modal to show camera image */}
                         <Modal
                            show={showModal}
                            onHide={closeModal}
                            position='center'
                            size="md"
                        >
                            <Modal.Header>
                                <Modal.Title>
                                    <div>{selectedCameraName}</div>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body
                                style={{
                                    height: imageLoaded ? "auto" : "300px", // Reserve space
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                {selectedImageUrl ? (
                                    <div
                                        style={{
                                            position: "relative",
                                            overflow: "hidden",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        <img
                                            src={selectedImageUrl}
                                            alt="Camera Preview"
                                            onLoad={handleImageLoad}
                                              style={{
                                                width: "100%",
                                                height: "100%", // 👈 Stretch to container height
                                                objectFit: "cover", // 👈 Keep image ratio nicely
                                                filter: animate ? "blur(0px)" : "blur(20px)",
                                                opacity: animate ? 1 : 0.7,
                                                transition: "filter 0.8s ease, opacity 0.8s ease",
                                            }}
                                        />
                                       
                                    </div>
                                ) : (
                                    <NoImageAvailable />
                                )}
                            </Modal.Body>
                          
                        </Modal>

                    </div>
                    
                    {/* Instructions */}
                    <div className="tip-buttons-container">
                        { !isSmallScreen && 
                        <div className="tip-guidelines-container">
                            <div className="tip-content">
                                <div className="guidelines-title">Tip:</div>
                                Drag cameras from the left panel onto your site plan. You can reposition them anytime by dragging.
                            </div>
                            
                            <div className="guideline-content">
                                <div className="guidelines-title">Placement Guidelines:</div>
                                <ul className="guideline-list">
                                    <li className="guideline-item">Cover all entry points</li>
                                    <li className="guideline-item">Avoid overlapping coverage</li>
                                    <li className="guideline-item">Consider camera range</li>
                                    <li className="guideline-item">Check for blind spots</li>
                                </ul> 
                            </div>
                            <div className="tip-content">
                                <div className="guidelines-title">Camera Removal:</div>
                                Drag a camera and drop it in the delete zone to remove it.
                            </div>
                        </div>
                        // :
                        // <p onClick={() => setOpenGuidelinePopUp(true)} className="view-guideline-btn">View Guidelines</p>
                        }

                        <div className="save-reset-buttons">
                            <button className="reset-pos-button" onClick = {handleGoToUploadFile}><i className="fa-solid fa-caret-left"></i> Back</button>
                            <button className="reset-pos-button" onClick = {handleGoToSaveConfig}>Next <i className="fa-solid fa-caret-right"></i></button>
                            <button className="reset-pos-button" onClick={() => setShowUndoChangesConfirmation(true)} disabled={cameraPositions.length>0?false:true}><i className="fa-solid fa-rotate"></i> Reset Positions</button>
                        </div>

                        {isSmallScreen && 
                        <div className="tip-guidelines-container">
                            <div className="tip-content">
                                <div className="guidelines-title">Tip:</div>
                                Drag cameras from the left panel onto your site plan. You can reposition them anytime by dragging.
                            </div>
                            
                            <div className="guideline-content">
                                <div className="guidelines-title">Placement Guidelines:</div>
                                <ul className="guideline-list">
                                    <li className="guideline-item">Cover all entry points</li>
                                    <li className="guideline-item">Avoid overlapping coverage</li>
                                    <li className="guideline-item">Consider camera range</li>
                                    <li className="guideline-item">Check for blind spots</li>
                                </ul> 
                            </div>
                            <div className="tip-content">
                                <div className="guidelines-title">Camera Removal:</div>
                                Drag a camera and drop it in the delete zone to remove it.
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            :
            // Save Config component
            <SaveConfig
            canvascamImagesRef = {canvascamImagesRef}
            isUploaded = {isUploaded}
            uploadedUrl = {uploadedUrl}
            step = {step}
            setStep = {setStep}
            cameraPositions ={cameraPositions}
            totalCameras = {totalCameras}
            filteredCameraList = {filteredCameraList}
            handleSaveLayout = {handleSaveLayout}
            handleGoToCameraPlacement = {handleGoToCameraPlacement}
            searchItem = {searchItem}
            handleSearchItem = {handleSearchItem}
            handleClearSearch = {handleClearSearch}
            totalOnlineCams = {totalOnlineCams}
            hwid = {hwid}
            userBusinessRole = {userBusinessRole}
            />
            }

            {/* Modal to remove a camera */}
            <Modal size='md' show={showRemoveCamConfirmation} onHide={() => cancelRemoveCam(camIdToRemove)}>
                <Modal.Header closeButton className='delete-modal-header'>
                    <Modal.Title>
                    <span className='delete-modal-title'>
                        Confirm Remove
                    </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='delete-modal-body'>
                    <div style={{ marginBottom: '1em' }}>
                    Are you sure you want to remove the following camera?
                    <div>
                        {camNameToRemove}
                    </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {
                    <Button variant="danger" size='sm' onClick={() => handleRemoveCam(camIdToRemove, camNameToRemove)}>Remove</Button>
                    }
                    <Button variant="secondary" size='sm' onClick={() => cancelRemoveCam(camIdToRemove)}>Cancel</Button>
                    </div>
                </Modal.Body>           
            </Modal>
            
            {/* Modal to undo all unsaved changes */}
             <Modal size='md' show={showUndoChangesConfirmation} onHide={cancelUndoChanges}>
                <Modal.Header closeButton className='delete-modal-header'>
                    <Modal.Title>
                    <span className='delete-modal-title'>
                        Comfirm Undo Changes
                    </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='delete-modal-body'>
                    <div style={{ marginBottom: '1em' }}>
                    Are you sure you want to undo all unsaved changes?
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {
                    <Button variant="danger" size='sm' onClick={handleUndoUnsavedChanges}>Yes</Button>
                    }
                    <Button variant="secondary" size='sm' onClick={cancelUndoChanges}>Cancel</Button>
                    </div>
                </Modal.Body>           
            </Modal>

        </>
    )
};

export default SitePlan;